// import React from 'react';
// import './compliance_reconciliation.css';
// import leftImage from "../../../img/des_sec/Compliance Reconciliation.svg"
// import card1 from "../../../img/des_sec/comp_card_1.svg"
// import card2 from "../../../img/des_sec/comp_card_2.svg"
// import card3 from "../../../img/des_sec/comp_card_3.svg"
// import { useRef } from 'react';

// const ComplianceReconciliation = () => {

//     const sliderRef = useRef(null);
      
//         const scrollLeft = () => {
//           if (sliderRef.current) {
//             sliderRef.current.scrollBy({ left: -200, behavior: 'smooth' });
//           }
//         };
      
//         const scrollRight = () => {
//           if (sliderRef.current) {
//             sliderRef.current.scrollBy({ left: 200, behavior: 'smooth' });
//           }
//         };
//   return (
//     <div className="onboarding-container-cr">
//       {/* Background image (half flex design) */}
//       <div className="background-image-cr"></div>
      
//       <div className="content-wrapper-cr">
//         {/* Left side - single illustration image */}
//         <div className="left-illustration-cr">
//           <img src={leftImage} alt="Onboarding Illustration" />
//         </div>
        
//         {/* Right side content */}
//         <div className="right-content-cr">
//           {/* Title */}
//           <h1 className="title-cr">Compliance Reconciliation</h1>
          
//            {/* Cards slider container */}
//            <div className="cards-slider-container">
//               <button className="slider-arrow left-arrow" onClick={scrollLeft}>&lt;</button>
              
//               {/* Cards stack with slider functionality */}
//               <div className="cards-stack-cr" ref={sliderRef}>
//                 <img src={card1} alt="Instant Aadhaar Verification" className="feature-card-cr" />
//                 <img src={card2} alt="Customizable Approval Workflows" className="feature-card-cr" />
//                 <img src={card3} alt="Integrated Agency Management" className="feature-card-cr" />
//               </div>
              
//               <button className="slider-arrow right-arrow" onClick={scrollRight}>&gt;</button>
//             </div>
          
          
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ComplianceReconciliation;

import React, { useRef, useEffect, useState } from 'react';
import { useSpring, animated } from 'react-spring';
import './compliance_reconciliation.css';
import leftImage from "../../../img/des_sec/Compliance Reconciliation.svg"
import card1 from "../../../img/des_sec/comp_card_1.svg"
import card2 from "../../../img/des_sec/comp_card_2.svg"
import card3 from "../../../img/des_sec/comp_card_3.svg"

const ComplianceReconciliation = () => {
  const [inView, setInView] = useState(false);
  const containerRef = useRef(null);
  const sliderRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
        } else {
          setInView(false);
        }
      },
      {
        threshold: 0.2,
        rootMargin: '-50px 0px'
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);

  const scrollLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: -200, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: 200, behavior: 'smooth' });
    }
  };

  // Animation for left illustration
  const leftIllustrationAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateX(0px) scale(1)' : 'translateX(-30px) scale(0.95)',
    config: { 
      tension: 160, 
      friction: 30,
      mass: 1.2
    },
    delay: inView ? 100 : 0
  });

  // Animation for title
  const titleAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px)' : 'translateY(20px)',
    config: { 
      tension: 180, 
      friction: 35,
      mass: 1
    },
    delay: inView ? 250 : 0
  });

  // Animation for left arrow
  const leftArrowAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateX(0px) scale(1)' : 'translateX(-10px) scale(0.9)',
    config: { 
      tension: 150, 
      friction: 25,
      mass: 0.8
    },
    delay: inView ? 400 : 0
  });

  // Animation for right arrow
  const rightArrowAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateX(0px) scale(1)' : 'translateX(10px) scale(0.9)',
    config: { 
      tension: 150, 
      friction: 25,
      mass: 0.8
    },
    delay: inView ? 400 : 0
  });

  // Individual card animations with staggered delays
  const card1Animation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px) scale(1)' : 'translateY(20px) scale(0.95)',
    config: { 
      tension: 140, 
      friction: 25,
      mass: 0.9
    },
    delay: inView ? 550 : 0
  });

  const card2Animation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px) scale(1)' : 'translateY(20px) scale(0.95)',
    config: { 
      tension: 140, 
      friction: 25,
      mass: 0.9
    },
    delay: inView ? 700 : 0
  });

  const card3Animation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px) scale(1)' : 'translateY(20px) scale(0.95)',
    config: { 
      tension: 140, 
      friction: 25,
      mass: 0.9
    },
    delay: inView ? 850 : 0
  });

  return (
    <div className="onboarding-container-cr" ref={containerRef}>
      {/* Background image (half flex design) */}
      <div className="background-image-cr"></div>
      
      <div className="content-wrapper-cr">
        {/* Left side - single illustration image */}
        <animated.div 
          className="left-illustration-cr"
          style={{
            ...leftIllustrationAnimation,
            position: 'relative',
            zIndex: 1
          }}
        >
          <img src={leftImage} alt="Compliance Reconciliation Illustration" />
        </animated.div>
        
        {/* Right side content */}
        <div className="right-content-cr">
          {/* Title */}
          <animated.h1 
            className="title-cr"
            style={{
              ...titleAnimation,
              position: 'relative',
              zIndex: 1
            }}
          >
            Compliance Reconciliation
          </animated.h1>
          
           {/* Cards slider container */}
           <div className="cards-slider-container">
              <animated.button 
                className="slider-arrow left-arrow" 
                onClick={scrollLeft}
                style={{
                  ...leftArrowAnimation,
                  position: 'relative',
                  zIndex: 1
                }}
              >
                &lt;
              </animated.button>
              
              {/* Cards stack with slider functionality */}
              <div className="cards-stack-cr" ref={sliderRef}>
                <animated.img 
                  src={card1} 
                  alt="Compliance Feature 1" 
                  className="feature-card-cr"
                  style={{
                    ...card1Animation,
                    position: 'relative',
                    zIndex: 1
                  }}
                />
                <animated.img 
                  src={card2} 
                  alt="Compliance Feature 2" 
                  className="feature-card-cr"
                  style={{
                    ...card2Animation,
                    position: 'relative',
                    zIndex: 1
                  }}
                />
                <animated.img 
                  src={card3} 
                  alt="Compliance Feature 3" 
                  className="feature-card-cr"
                  style={{
                    ...card3Animation,
                    position: 'relative',
                    zIndex: 1
                  }}
                />
              </div>
              
              <animated.button 
                className="slider-arrow right-arrow" 
                onClick={scrollRight}
                style={{
                  ...rightArrowAnimation,
                  position: 'relative',
                  zIndex: 1
                }}
              >
                &gt;
              </animated.button>
            </div>
        </div>
      </div>
    </div>
  );
};

export default ComplianceReconciliation;